(() => {
  'use strict';
  const singleton = Symbol.for('ArtMotri.membership.tabs.v2');
  if (window[singleton]) return;
  window[singleton] = true;
  const mounted = new Map();
  const teardown = root => {
    const controller = mounted.get(root);
    if (!controller) return;
    controller.abort();
    mounted.delete(root);
    root.classList.remove('am-tabs-enhanced');
  };
  const initialiseTabs = root => {
    if (mounted.has(root)) return;
    const tablist = root.querySelector('[data-am-tablist]');
    const tabs = [...root.querySelectorAll('[data-am-tab]')];
    const panels = [...root.querySelectorAll('[data-am-panel]')];
    const panelByName = new Map(panels.map(panel => [panel.dataset.amPanel, panel]));
    if (!tablist || !tabs.length || tabs.some(tab => !panelByName.has(tab.dataset.amTab))) return;
    const controller = new AbortController();
    mounted.set(root, controller);
    const on = (node, type, callback) => node.addEventListener(type, callback, {signal:controller.signal});
    tablist.setAttribute('role', 'tablist');
    tabs.forEach(tab => {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panelByName.get(tab.dataset.amTab).id);
    });
    panels.forEach(panel => {
      panel.setAttribute('role', 'tabpanel');
      panel.tabIndex = 0;
    });
    const select = (name, {focus = false, updateHash = false} = {}) => {
      if (!panelByName.has(name)) return;
      tabs.forEach(tab => {
        const active = tab.dataset.amTab === name;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) {
          tab.focus({preventScroll:true});
          tab.scrollIntoView({block:'nearest', inline:'nearest'});
        }
      });
      panels.forEach(panel => { panel.hidden = panel.dataset.amPanel !== name; });
      if (updateHash) history.replaceState(null, '', '#panel-' + name);
    };
    const hashName = () => {
      const name = location.hash.startsWith('#panel-') ? location.hash.slice(7) : '';
      return panelByName.has(name) ? name : null;
    };
    const modifiedClick = event => event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
    tabs.forEach((tab, index) => {
      on(tab, 'click', event => {
        if (modifiedClick(event)) return;
        event.preventDefault();
        select(tab.dataset.amTab, {updateHash:true});
      });
      on(tab, 'keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else if (event.key === 'Enter' || event.key === ' ') next = index;
        else return;
        event.preventDefault();
        select(tabs[next].dataset.amTab, {focus:true, updateHash:true});
      });
    });
    root.querySelectorAll('[data-am-open-tab]').forEach(link => {
      on(link, 'click', event => {
        if (modifiedClick(event) || !panelByName.has(link.dataset.amOpenTab)) return;
        event.preventDefault();
        select(link.dataset.amOpenTab, {focus:true, updateHash:true});
      });
    });
    on(window, 'hashchange', () => select(hashName() || tabs[0].dataset.amTab));
    select(hashName() || tabs[0].dataset.amTab);
    root.classList.add('am-tabs-enhanced');
  };
  const initialise = (scope = document) => {
    for (const root of [...mounted.keys()]) if (!root.isConnected) teardown(root);
    const selector = '.am-membership-root[data-am-my-collection]';
    if (scope.matches?.(selector)) initialiseTabs(scope);
    scope.querySelectorAll(selector).forEach(initialiseTabs);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(), {once:true});
  else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const root of [...mounted.keys()]) if (root === event.target || event.target.contains(root)) teardown(root);
  });
  window.addEventListener('pagehide', () => [...mounted.keys()].forEach(teardown));
  window.addEventListener('pageshow', event => { if (event.persisted) initialise(); });
})();
